import React, { useState } from "react";
import { fixNumbers } from "../helper/helper";

const PASSPORT_NUMBER_REGEX = new RegExp("^[a-z,A-Z]{1}(\\d){8}$");

// useForm functional component
export const useForm = (callback: any, initialState = {}, setErrors: any) => {
  const [values, setValues] = useState(initialState) as any;

  // onPress
  const onPress = (event: React.KeyboardEvent<HTMLInputElement>) => {

    let mainKey = event.key;
    let
      persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    if (persianNumbers.includes(event.key)) {
      mainKey = persianNumbers.indexOf(event.key).toString();
    }

    let keys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    if (!keys.includes(mainKey)) {
      return event.preventDefault();
    }
  }
  // onPress
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const id = { '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4', '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9' };
    return event.currentTarget.value.replace(/[^0-9.]/g, function (w: any) {
      // @ts-ignore
      return id[w] || w;
    });

  }



  // onChange
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let targetValue = fixNumbers(event.target.value);
    event.target.classList.remove('input-error');
    setErrors([]);
    setValues({
      ...values, [event.target.name]:
        targetValue
    });
  };

  // onCaptchaChange
  const onCaptchaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let targetValue = fixNumbers(event.target.value);
    event.target.classList.remove('input-error');
    setErrors([]);
    setValues({
      ...values, captcha: {
        code: targetValue,
        id: event.target.id
      }
    });
  }

  // onBirthDateChane
  const onBirthDateChange = (birthDate: string) => {
    setValues({ ...values, birthDate });
  }

  // form validation

  // check national id validation
  function checkNationalId(code: any) {
    let L = code.length;

    if (L < 8 || parseInt(code, 10) === 0) return false;
    code = ('0000' + code).substr(L + 4 - 10);
    if (parseInt(code.substr(3, 6), 10) === 0) return false;
    let c = parseInt(code.substr(9, 1), 10);
    let s = 0;
    for (let i = 0; i < 9; i++)
      s += parseInt(code.substr(i, 1), 10) * (10 - i);
    s = s % 11;
    return (s < 2 && c === s) || (s >= 2 && c === (11 - s));
    // return true;
  }
  // form validation

  // check national id validation
  function checkPassportNumber(code: any) {
    return PASSPORT_NUMBER_REGEX.test(code); 
  }

  // check mobile number validation
  function checkMobileNumber(mobile: any) {
    var regex = new RegExp("^09\\d{9}$");
    return regex.test(mobile);
  }

  function isValidate(values: any) {

    for (const item in values) {
      if (values[item] === '') {
        setErrors([{ 'field': item, 'message': 'لطفا فیلد مورد نظر را پر کنید' }])
        return false;
      }
    }

    if (!checkNationalId(values['nationalId'])) {
      setErrors([{ 'field': 'nationalId', 'message': 'فرمت کد ملی اشتباه است .' }])
      return false;
    }

    if (values.hasOwnProperty("mobileNumber") && !checkMobileNumber(values['mobileNumber'])) {
      setErrors([{ 'field': 'mobileNumber', 'message': 'فرمت شماره موبایل اشتباه است .' }])
      return false;
    }

    if (values.hasOwnProperty("captcha") && values['captcha'].code === '') {
      setErrors([{ 'field': 'captcha', 'message': 'لطفا کد کپچا را وارد کنید .' }])
      return false;
    }

    if (values.hasOwnProperty("passportNumber") && !checkPassportNumber(values['passportNumber'])) {
      setErrors([{ 'field': 'passportNumber', 'message': 'فرمت شماره گذرنامه اشتباه است .' }])
      return false;
    }

    return true;
  }

  // onSubmit
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isValidate(values)) {
      await callback(); // triggering the callback
    }
  };

  // return values
  return {
    onChange,
    onPress,
    onKeyDown,
    onCaptchaChange,
    onBirthDateChange,
    onSubmit,
    values,
    setValues,
  };
}